import '../../style/index.less';
import './index.less';



// WEBPACK FOOTER //
// ./components/badge/style/index.tsx